import { render, staticRenderFns } from "./all-users.vue?vue&type=template&id=180b2454&"
import script from "./all-users.vue?vue&type=script&lang=js&"
export * from "./all-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports